export default "__VITE_ASSET__5d0aba63__"